// Public KPIs / commitments for Lenovo India CSR programmes.
// (Internally still keyed as `TARGETS` for backwards compatibility — user-facing label is "KPIs".)

export const TARGETS = [
  // ─── STEM Education ─────────────────────────────────────────────────────────
  {
    id: "stem-students-1l",
    pillar: "stem",
    label: "Reach 1,00,000 government-school students with experiential STEM",
    targetYear: 2027,
    target: 100000,
    actual: 62800,
    unit: "students",
  },
  {
    id: "stem-schools-1200",
    pillar: "stem",
    label: "Activate STEM learning in 1,200 schools",
    targetYear: 2026,
    target: 1200,
    actual: 940,
    unit: "schools",
  },
  {
    id: "stem-teachers-6k",
    pillar: "stem",
    label: "Train 6,000 teachers in STEM pedagogy",
    targetYear: 2026,
    target: 6000,
    actual: 4350,
    unit: "teachers",
  },
  {
    id: "stem-labs-150",
    pillar: "stem",
    label: "Set up 150 innovation / STEM labs",
    targetYear: 2027,
    target: 150,
    actual: 98,
    unit: "labs",
  },

  // ─── Digital Literacy ───────────────────────────────────────────────────────
  {
    id: "dgl-learners-75k",
    pillar: "digital",
    label: "Equip 75,000 learners with ICT, coding & AI literacy",
    targetYear: 2027,
    target: 75000,
    actual: 41200,
    unit: "learners",
  },
  {
    id: "dgl-devices-20k",
    pillar: "digital",
    label: "Deploy 20,000 devices in government schools",
    targetYear: 2026,
    target: 20000,
    actual: 16400,
    unit: "devices",
  },
  {
    id: "dgl-girls-50pct",
    pillar: "digital",
    label: "Ensure 50% girl participation in digital programmes",
    targetYear: 2026,
    target: 50,
    actual: 47,
    unit: "%",
  },
  {
    id: "dgl-govt-schools-800",
    pillar: "digital",
    label: "Onboard 800 government schools to digital classrooms",
    targetYear: 2027,
    target: 800,
    actual: 560,
    unit: "schools",
  },

  // ─── Employability & Skilling ───────────────────────────────────────────────
  {
    id: "emp-youth-25k",
    pillar: "employability",
    label: "Skill 25,000 youth for IT-ITES & manufacturing careers",
    targetYear: 2027,
    target: 25000,
    actual: 14800,
    unit: "youth",
  },
  {
    id: "emp-placement-70",
    pillar: "employability",
    label: "Achieve 70% placement across skilling cohorts",
    targetYear: 2026,
    target: 70,
    actual: 64,
    unit: "%",
  },
  {
    id: "emp-women-40pct",
    pillar: "employability",
    label: "Sustain 40%+ women representation in skilling",
    targetYear: 2026,
    target: 40,
    actual: 43,
    unit: "%",
  },
  {
    id: "emp-firstgen-8k",
    pillar: "employability",
    label: "Place 8,000 first-generation learners in formal jobs",
    targetYear: 2027,
    target: 8000,
    actual: 5100,
    unit: "youth",
  },

  // ─── Sustainability ─────────────────────────────────────────────────────────
  {
    id: "sus-trees-5l",
    pillar: "sustainability",
    label: "Plant 5,00,000 native trees with communities",
    targetYear: 2028,
    target: 500000,
    actual: 312000,
    unit: "trees",
  },
  {
    id: "sus-ewaste-10kt",
    pillar: "sustainability",
    label: "Responsibly recycle 10,000 tonnes of e-waste",
    targetYear: 2027,
    target: 10000,
    actual: 6200,
    unit: "tonnes",
  },
  {
    id: "sus-farmers-5k",
    pillar: "sustainability",
    label: "Enhance livelihoods for 5,000 farming families",
    targetYear: 2027,
    target: 5000,
    actual: 2900,
    unit: "families",
  },
  {
    id: "sus-villages-300",
    pillar: "sustainability",
    label: "Reach 300 villages with climate-resilient interventions",
    targetYear: 2028,
    target: 300,
    actual: 184,
    unit: "villages",
  },
];
